import erModel from "../../../../../pages/rolling-stock/docs/ER-model.png";
import * as React from 'react';
export default {
  erModel,
  React
};